import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqss3zkgpy: FaireProductEntity = {
  token: "p_kqss3zkgpy",
  type: "product",
  name: "Minnesota Shapes in Purple and Gold Mens Socks",
  brandName: "Buy Socks You All",
  imageUrl:
    "https://cdn.faire.com/fastly/66a7fcfaba50af1e70c2cbbd11d8d6b6ae7ed525739e8d84eaf46f6a324387e1.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b98eb16c2c4bf43b73a581a6c7b633ea3d53a775a6b0935c0a9204e0587b021a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
